import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-term-and-condition',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermAndConditionComponent implements OnInit {
  @Input() isShowHeader: boolean = true;
  @Input() isClose: boolean = false;
  @Output() onClose = new EventEmitter;

  public date_now = new Date();
  public year_now = this.date_now.getFullYear();

  constructor() { }

  ngOnInit(): void {
  }

  close(): void {
    this.onClose.emit(true);
  }

}
